import Http from './../http';

const prefix = '';

export const getToken = layoutId => Http.api().get(`${prefix}/${layoutId}`);

export const getUser = id => Http.authApi().get(`${prefix}/${id}`);

export const register = user => Http.api().post(`${prefix}/register`, user);

export const login = user => Http.api().post(`${prefix}/login`, user);

export const logout = () => {
  return Http.authApi().post(`${prefix}/logout`);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/login.js